export const DEFAULT_FRAME_TYPES = [
  "transformed",
  "original",
  "thermal",
  "delta",
  "bacterial",
  "fluoVisible",
  "fluorescent",
  "placeholder"
];
export const STANDARD_FRAME_TYPES = ["transformed", "original", "placeholder"];
export const THERMAL_FRAME_TYPES = { THERMAL: "thermal", DELTA: "delta" };
export const FLUORO_FRAME_TYPES = ["bacterial", "fluoVisible", "fluorescent"];
